export function generateSeededStats(seedString: string) {
  const seed = seedString.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0)

  return {
    volume: (seed % 100000) + 50000,
    change24h: (seed % 40) + 5,
    marketCap: (seed % 500000) + 100000,
    holders: (seed % 50) + 25,
    lastTrade: `${(seed % 3) + 1}h ago`,
  }
}

export function generateHoldingData(outcomeName: string, outcomeSlug: string, shares?: number, maxWinAmount?: number) {
  const seed = (outcomeName + outcomeSlug).split("").reduce((acc, char) => acc + char.charCodeAt(0), 0)
  const baseShares = 50 + (seed % 200) // 50-250 shares
  const simulatedShares = shares || baseShares
  const simulatedMaxWin = maxWinAmount || simulatedShares * (8 + (seed % 12)) // 8-20x multiplier

  return {
    shares: simulatedShares,
    maxWinAmount: simulatedMaxWin,
  }
}

// Format volume helper (unused but kept for future use)
// function formatVolume(value: number): string {
//   const absValue = Math.abs(value)
//   const sign = value >= 0 ? "" : "-"
//
//   if (absValue >= 1_000_000_000) {
//     return `${sign}${Number((absValue / 1_000_000_000).toFixed(2))}B`
//   }
//   if (absValue >= 1_000_000) {
//     return `${sign}${Number((absValue / 1_000_000).toFixed(2))}M`
//   }
//   if (absValue >= 1_000) {
//     return `${sign}${Number((absValue / 1_000).toFixed(1))}K`
//   }
//   return `${sign}${Number(absValue.toFixed(2))}`
// }
